export const isWebview =
  typeof window !== 'undefined' &&
  window.navigator.userAgent.toLowerCase().includes('su-pay')
